(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-custom-quote-template"]) return;
  try {
    
$(".contact-button").on('click', function(event){
$('#contact-form-product').toggle()
})


  } catch(e) { console.error(e); }
})();
})();
